export class LoadClientDetailsAction {
  static readonly type = '[ClientDetails] Load client';
  constructor(public customerId: number) {}
}

export class ResetClientDetailsAction {
  static readonly type = '[ClientDetails] Reset client details';
  constructor() {}
}
